/* Avaliações da PDP · faixas que andam · gerado por tema/aval.py (04/10).
   Sem JS, com "reduzir movimento" ou com 2 recados ou menos, as faixas ficam paradas e roláveis (o CSS já cuida). */
(function(){
  var s = document.getElementById('avaliacoes');
  if(!s || !s.classList.contains('rv')) return;
  var VEL = 26;   /* px por segundo: devagar o bastante para ler */

  /* recado longo: 6 linhas + "Ler tudo"; aberto, a faixa dele para até fechar */
  function poeLer(raiz){
    [].forEach.call(raiz.querySelectorAll('.rv__x'), function(x){
      var b = x.closest('.rv__b');
      if(b.querySelector('.rv__ler') || x.scrollHeight <= x.clientHeight + 2) return;
      var l = document.createElement('button'); l.type = 'button'; l.className = 'rv__ler'; l.textContent = 'Ler tudo';
      x.insertAdjacentElement('afterend', l);
    });
  }
  s.addEventListener('click', function(e){
    var l = e.target.closest && e.target.closest('.rv__ler'); if(!l) return;
    var b = l.closest('.rv__b'), fa = l.closest('.rv__fa'), abre = !b.hasAttribute('data-aberto');
    b.toggleAttribute('data-aberto', abre); l.textContent = abre ? 'Fechar' : 'Ler tudo';
    if(fa) fa.toggleAttribute('data-lendo', !!fa.querySelector('.rv__b[data-aberto]'));
  });
  poeLer(s);

  var fx = s.querySelector('.rv__fx');
  var reduz = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!fx || fx.hasAttribute('data-parada') || reduz) return;
  var faixas = [].slice.call(s.querySelectorAll('.rv__fa'));
  /* 3 recados: uma faixa só (duas faixas repetiriam o mesmo recado lado a lado) */
  if(faixas.length > 1 && s.querySelectorAll('.rv__b').length < 4){
    var tr1 = faixas[0].querySelector('.rv__tr');
    faixas.slice(1).forEach(function(fa){ [].slice.call(fa.querySelectorAll('.rv__b')).forEach(function(b){ tr1.appendChild(b); }); fa.remove(); });
    faixas = [faixas[0]];
  }

  function clona(o){
    var c = o.cloneNode(true);
    c.setAttribute('data-clone', ''); c.setAttribute('aria-hidden', 'true'); c.inert = true;
    c.removeAttribute('data-aberto');
    var l = c.querySelector('.rv__ler'); if(l) l.textContent = 'Ler tudo';
    return c;
  }
  function monta(){
    faixas.forEach(function(fa){
      var tr = fa.querySelector('.rv__tr');
      [].forEach.call(tr.querySelectorAll('[data-clone]'), function(n){ n.remove(); });
      var orig = [].slice.call(tr.children); if(!orig.length) return;
      var alvo = fa.clientWidth + 40, k = 0;
      while(tr.getBoundingClientRect().width < alvo && k < 10){ orig.forEach(function(o){ tr.appendChild(clona(o)); }); k++; }
      [].slice.call(tr.children).forEach(function(o){ tr.appendChild(clona(o)); });   /* o conjunto duas vezes: -50% emenda sem salto */
      fa.style.setProperty('--dur', Math.round(tr.getBoundingClientRect().width / 2 / VEL) + 's');
    });
    s.setAttribute('data-anda', '');
  }
  monta();
  var larg = innerWidth, rz = 0;
  addEventListener('resize', function(){
    if(innerWidth === larg) return; larg = innerWidth;
    clearTimeout(rz); rz = setTimeout(function(){ s.removeAttribute('data-anda'); monta(); }, 200);
  });

  /* SEM BOTÃO PAUSAR NEM DICA (Romulo, 04/10: "pra que essa poluição desnecessária?"): a faixa já para com o mouse
     e com o toque, para fora da tela e não anda com prefers-reduced-motion. */
  /* tocar para: a faixa tocada fica parada e volta 1,2 s depois de soltar */
  faixas.forEach(function(fa){
    var t = 0;
    fa.addEventListener('pointerdown', function(){ clearTimeout(t); fa.setAttribute('data-toque', ''); });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function(ev){
      fa.addEventListener(ev, function(){ clearTimeout(t); t = setTimeout(function(){ fa.removeAttribute('data-toque'); }, 1200); });
    });
  });

  /* fora da tela, nada anda */
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){ s.toggleAttribute('data-fora', !es[0].isIntersecting); }).observe(fx);
  }
})();
